import styled from '@emotion/styled'
import { Link } from 'react-router'
import { font, colors, spacing, shadow } from '@mobi/component-library/Foundations'

export const EventContainerStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  padding: spacing.sm,
  alignItems: 'stretch',
  alignSelf: 'stretch',
  borderRadius: spacing.md,
  boxShadow: shadow.sm,
  border: `1px solid ${colors.neutral[200]}`,
  backgroundColor: colors.white,
})

export const LinkStyled = styled(Link)({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  gap: spacing.smx2,

  padding: 0,
  margin: 0,
  color: 'unset',
  textDecoration: 'unset',
  transition: 'opacity 300ms ease',
  WebkitTapHighlightColor: 'transparent',

  '@media (hover: hover)': {
    ':hover': { opacity: 0.6 },
  },
})

export const EventDetailsContainerStyled = styled.div({
  display: 'flex',
  flex: '1 0 0',
  alignItems: 'center',
  flexDirection: 'row',

  paddingBottom: spacing.smx1,
  borderBottom: `1px solid ${colors.neutral[200]}`,
})

export const RaceNumberContainerStyled = styled.div({
  display: 'flex',
  borderRadius: spacing.smx2,
  background: colors.neutral[100],
  padding: spacing.smx2,
})

export const RaceNumberStyled = styled.div({
  fontFamily: font.family.primary,
  fontSize: font.size.sm.fontSize,
  lineHeight: font.size.sm.lineHeight,
  fontWeight: font.weight.regular,
  color: colors.neutral[900],
})

export const RaceCourseNameStyled = styled.div({
  fontFamily: font.family.primary,
  fontSize: font.size.md.fontSize,
  lineHeight: font.size.md.lineHeight,
  fontWeight: font.weight.regular,
  color: colors.neutral[800],
})

export const EventCountdownStyled = styled.div({
  // countdown is right aligned within an existing stretched flexbox
  flex: '1 0 0',
  display: 'flex',
  alignItems: 'end',
  flexDirection: 'column',
})
